

































import Vue from 'vue'
import Component from 'vue-class-component'

// Define the component in class-style
@Component
export default class Dashboard extends Vue {
  mounted() {
    this.$store.dispatch('setPageTitle', { pageTitle: 'Dashboard' })
  }

  onClick() {
    this.$router.push({
      name: 'CustomerCreate',
      params: { merchantID: this.$store.getters.currentMerchant.id }
    })
  }
}
